import { TypeAirport } from "@/lib/redux/features/flight/type"
import { removeVietnameseChars } from "@/utils/string/removeVietnameseChars"

export type AirportSearchItem = TypeAirport & { searchValue?: unknown; matchers?: Record<string, unknown> }

export type CityAirportGroup = {
  firstIndex: number
  countryCode: string
  country: string
  cityKey: string
  cityVi: string
  cityEn: string
  airports: AirportSearchItem[]
}

export function cityGroupKey(airport: TypeAirport): string {
  if (!airport) return "ZZ::unknown"
  const cityLabel = (airport.cityVi || airport.cityEn || airport.city || "").trim()
  const norm = removeVietnameseChars(cityLabel)
    .toLowerCase()
    .replace(/\s+/g, "_")
  return `${airport.countryCode || "ZZ"}::${norm}`
}

export function groupAirportsByCity(airports: AirportSearchItem[]): CityAirportGroup[] {
  const byKey = new Map<string, CityAirportGroup>()
  airports.forEach((airport, idx) => {
    if (!airport) return
    const key = cityGroupKey(airport)
    let g = byKey.get(key)
    if (!g) {
      g = {
        firstIndex: idx,
        countryCode: airport.countryCode,
        country: airport.country,
        cityKey: key,
        cityVi: airport.cityVi,
        cityEn: airport.cityEn,
        airports: [],
      }
      byKey.set(key, g)
    }
    g.airports.push(airport)
  })
  return Array.from(byKey.values()).sort((a, b) => a.firstIndex - b.firstIndex)
}

export type CountryCityNested = {
  countryCode: string
  country: string
  cityGroups: CityAirportGroup[]
}

export function nestGroupsByCountry(groups: CityAirportGroup[]): CountryCityNested[] {
  const order: string[] = []
  const map = new Map<string, CountryCityNested>()
  for (const g of groups) {
    const cc = g.countryCode || "__"
    if (!map.has(cc)) {
      order.push(cc)
      map.set(cc, { countryCode: cc, country: g.country, cityGroups: [] })
    }
    map.get(cc)!.cityGroups.push(g)
  }
  return order.map(cc => map.get(cc)!)
}
